var map = {
	"./glycemicIndexModules.json": [
		869,
		869
	],
	"./insulinDosing.json": [
		611,
		611
	],
	"./ketoneModules.json": [
		742,
		742
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 916;
module.exports = webpackAsyncContext;